import FilterLabelFormatter from '../FilterLabelFormatter'

import ForChildrenWFFMDataExchange from '@/services/ForChildrenWFFMDataExchange'

/**
 * A mixin adding for-children editing logic and data
 */
export default {
  mixins: [
    FilterLabelFormatter,
  ],
  data () {
    return {
      dx: { forChildren: new ForChildrenWFFMDataExchange(this.form) },
      popups: { forChildren: false },
      forChildren: [],
    }
  },
  created () {
    this.forChildren = this.dx.forChildren.data
  },
  computed: {
    selectedForChildren () {
      return this.forChildren.filter(item => item.selected)
    },
    selectedForChildrenLabel () {
      return this.getFormattedFilterLabel(this.selectedForChildren, 'Dla dzieci')
    },
    selectedForChildrenValue () {
      return this.getFormattedFilterValue(this.selectedForChildren, 'Dla dzieci')
    },
  },
}



// WEBPACK FOOTER //
// ./src/components/search/logic/ForChildren.js